﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXControlView = void 0;
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const com = require("../tmpls");
const AppVX_1 = require("../../AppVX");
const BiMath_1 = require("../../BiMath");
const VXControlViewTabController_1 = require("./loanCalcViewClasses/VXControlViewTabController");
const VXSControlViewTabController_1 = require("./loanCalcViewClasses/VXSControlViewTabController");
class VXControlView extends com.CmpVXControl {
    constructor() {
        super();
        this._validatorCost = BiMath_1.BiMath.ToBI("32000000");
        this.cacheTransferValueUSDL = BigInt(0);
        this._app = AppVX_1.AppVX.Inst;
        this._tabVXControl = new VXControlViewTabController_1.VXControlViewTabController(this);
        this._tabVXSControl = new VXSControlViewTabController_1.VXSControlViewTabController(this);
        globalThis.refreshHandler = () => __awaiter(this, void 0, void 0, function* () { return this.refreshAsync(); });
        this._app.chain.onChangeAccount.addHandler(() => __awaiter(this, void 0, void 0, function* () {
            yield this.refreshAsync();
        }));
        this.ctrls.btnTabVXS.disable();
        this.ctrls.btnTabVXS.onclick = () => {
            this.ctrls.blockVXTabs.hide();
            this.ctrls.blockVXSTabs.show();
            this._tabVXSControl.activeTab(this.ctrls.tabVXSConfig);
        };
        this.ctrls.btnTabVX.onclick = () => {
            this.ctrls.blockVXTabs.show();
            this.ctrls.blockVXSTabs.hide();
            this._tabVXControl.activeTab(this.ctrls.tabStake);
        };
        this.ctrls.btnInfoToggle.onclick = () => {
            let isOpen = this.ctrls.btnInfoToggle.text == "-";
            this.ctrls.btnInfoToggle.text = isOpen ? "+" : "-";
            this.ctrls.blockSVInfoAdditional.showSet(!isOpen);
        };
        this.ctrls.btnConnectWallet.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const modalWalletError = new modalCom.DialogOk("It looks like your browser doesn't have a wallet installed. Please use a browser with a functioning MetaMask or Rabby extension", "Information");
            const modalAgreement = new modalCom.DialogOk("", "Information");
            modalAgreement.ctrls.body.html = "Please confirm that you have read and agree to the <a href=\"https://up.docs.plusx.app/?folder=ValidatorX&article=Terms%20of%20Use\" target='_blank'>Terms of Use</a> by clicking the button below.";
            modalAgreement.ctrls.body.onclick = (e) => e.stopPropagation();
            const result = yield modalAgreement.show();
            if (result != modalCom.ModalDialogResult.Ok)
                return;
            this.ctrls.btnConnectWallet.disable();
            try {
                const account = yield this._app.chain.getAccountAsync();
                if (!account) {
                    this.ctrls.btnConnectWallet.enable();
                    if (account != false)
                        modalWalletError.show();
                    return;
                }
                this.ctrls.btnConnectWallet.enable();
                yield this.refreshAsync(true);
            }
            catch (error) {
                this.ctrls.btnConnectWallet.enable();
                modalWalletError.show();
                throw error;
            }
        });
        this._tabVXControl.activeTab(this.ctrls.tabStake);
        this.ctrls.btnAddToken.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._app.chain.account)
                yield this._app.chain.getAccountAsync();
            if (this._app.chain.account)
                yield this._app.chain.addTokenToWalletAsync(this._app.chain.vx.address, "uPLS", 18);
        });
        ///*******************Stake*******************
        {
            let cacheStakeValue = BiMath_1.BiMath.Zero;
            let cacheStakeVXValue = BiMath_1.BiMath.Zero;
            let cacheStakeGasValue = BiMath_1.BiMath.Zero;
            const fillStakeOverview = () => {
                this.ctrls.lTxStakeVX.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(cacheStakeVXValue), 3);
                this.ctrls.lTxStakeValidatorsGas.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(cacheStakeGasValue), 3);
                this.ctrls.blockTxStakeValidatorsGas.showSet(cacheStakeGasValue != BiMath_1.BiMath.Zero);
            };
            const setStakeValue = () => {
                this.ctrls.iStakeValuePLS.value = BiMath_1.BiMath.ToEth(cacheStakeValue);
                let rangeValue = cacheStakeValue * BiMath_1.BiMath.Decimal / this._plsBalance;
                this.ctrls.rStakeValuePLS.value = parseInt(parseFloat(BiMath_1.BiMath.ToEth(rangeValue)) * 100 + "") + "";
                cacheStakeGasValue = cacheStakeValue * this._vxValidatorGas / this._validatorCost;
                cacheStakeValue -= cacheStakeGasValue;
                cacheStakeVXValue = cacheStakeValue * BiMath_1.BiMath.Decimal / this._vxRatio;
                if (parseFloat(BiMath_1.BiMath.ToEth(cacheStakeValue)) < 1)
                    this.ctrls.btnStakeSubmit.disable();
                else
                    this.ctrls.btnStakeSubmit.enable();
                if (!this._app.chain.account)
                    this.ctrls.btnStakeSubmit.disable();
                if (cacheStakeValue)
                    this.ctrls.iStakeValuePLS.removeClass("is-invalid");
                fillStakeOverview();
            };
            this.ctrls.iStakeValuePLS.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
                let value = this._clearValueFunc(this.ctrls.iStakeValuePLS.value);
                if (value === false) {
                    this.ctrls.iStakeValuePLS.value = BiMath_1.BiMath.ToEth(cacheStakeValue);
                    return;
                }
                cacheStakeValue = BiMath_1.BiMath.ToBI(value);
                setStakeValue();
            }));
            this.ctrls.rStakeValuePLS.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
                let rangeValue = BiMath_1.BiMath.ToBIFromNumber(parseInt(this.ctrls.rStakeValuePLS.value) / 100);
                cacheStakeValue = this._plsBalance * rangeValue / BiMath_1.BiMath.Decimal;
                setStakeValue();
            }));
            this.ctrls.btnStakeSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this._tabVXControl.awaitInLockUIAsync(this._app.chain.vx.stakeAsync(BiMath_1.BiMath.ToEth(cacheStakeValue + cacheStakeGasValue), false));
                if (result) {
                    this._successFunc();
                    this._tabVXControl.stakeReset();
                    yield this.refreshAsync();
                }
            });
        }
        ///*******************Unstake*******************
        {
            let cacheUnstakeVXValue = BiMath_1.BiMath.Zero;
            let cacheUnstakeValue = BiMath_1.BiMath.Zero;
            const fillUnstakeOverview = () => {
                this.ctrls.lTxUnstakeValue.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(cacheUnstakeValue), 3);
            };
            const setUnstakeValue = () => {
                cacheUnstakeValue = cacheUnstakeVXValue * this._vxRatio / BiMath_1.BiMath.Decimal;
                this.ctrls.iUnstakeValueUPLS.value = BiMath_1.BiMath.ToEth(cacheUnstakeVXValue);
                let rangeValue = cacheUnstakeVXValue * BiMath_1.BiMath.Decimal / this._vxBalance;
                this.ctrls.rUnstakeValueUPLS.value = parseInt(parseFloat(BiMath_1.BiMath.ToEth(rangeValue)) * 100 + "") + "";
                if (parseFloat(BiMath_1.BiMath.ToEth(cacheUnstakeVXValue)) < 0.001)
                    this.ctrls.btnUnstakeSubmit.disable();
                else
                    this.ctrls.btnUnstakeSubmit.enable();
                if (!this._app.chain.account)
                    this.ctrls.btnUnstakeSubmit.disable();
                if (cacheUnstakeValue)
                    this.ctrls.iUnstakeValueUPLS.removeClass("is-invalid");
                fillUnstakeOverview();
            };
            this.ctrls.iUnstakeValueUPLS.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
                let value = this._clearValueFunc(this.ctrls.iUnstakeValueUPLS.value);
                if (value === false) {
                    setUnstakeValue();
                    return;
                }
                cacheUnstakeVXValue = BiMath_1.BiMath.ToBI(value);
                setUnstakeValue();
            }));
            this.ctrls.rUnstakeValueUPLS.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
                let rangeValue = BiMath_1.BiMath.ToBIFromNumber(parseInt(this.ctrls.rUnstakeValueUPLS.value) / 100);
                cacheUnstakeVXValue = this._vxBalance * rangeValue / BiMath_1.BiMath.Decimal;
                setUnstakeValue();
            }));
            this.ctrls.btnUnstakeSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this._tabVXControl.awaitInLockUIAsync(this._app.chain.vx.unstakeAsync(BiMath_1.BiMath.ToEth(cacheUnstakeVXValue), true));
                if (result) {
                    this._successFunc();
                    this._tabVXControl.unstakeReset();
                    yield this.refreshAsync();
                }
            });
            this.ctrls.btnUnstakeMax.onclick = () => __awaiter(this, void 0, void 0, function* () {
                this.ctrls.btnUnstakeMax.disable();
                const vxBalance = yield this._app.chain.vxERC20.balanceOf(this._app.chain.account);
                this.ctrls.btnUnstakeMax.enable();
                if (!vxBalance)
                    return;
                cacheUnstakeVXValue = BiMath_1.BiMath.ToBI(vxBalance);
                this.ctrls.iUnstakeValueUPLS.value = BiMath_1.BiMath.ToEth(cacheUnstakeVXValue);
                cacheUnstakeValue = cacheUnstakeVXValue * this._vxRatio / BiMath_1.BiMath.Decimal;
                if (parseFloat(BiMath_1.BiMath.ToEth(cacheUnstakeVXValue)) < 0.001)
                    this.ctrls.btnUnstakeSubmit.disable();
                else
                    this.ctrls.btnUnstakeSubmit.enable();
                if (!this._app.chain.account)
                    this.ctrls.btnUnstakeSubmit.disable();
                fillUnstakeOverview();
            });
        }
    }
    _successFunc() { new modalCom.DialogOk("The transaction was completed successfully.", "Information").show(); }
    _clearValueFunc(value) {
        if (value == "")
            return value;
        if (value.charAt(0) == ".")
            value = "0" + value;
        const regex = /^[0-9]+(\.[0-9]{0,18})?$/;
        //const regex = /^[0-9]+(\.[0-9]*)?$/;
        if (!regex.test(value))
            return false;
        return value;
    }
    _calcFeeFunc(loanBase, borrowRate) {
        const stage2 = BiMath_1.BiMath.ToBI("55.0");
        let fee = loanBase / BigInt(10); //0.1;
        if (fee > stage2) {
            fee = stage2;
            const fee_3stage = loanBase * borrowRate / BigInt(2) / BiMath_1.BiMath.Decimal;
            if (fee_3stage > fee)
                fee = fee_3stage;
        }
        return fee;
    }
    _refreshAdditionalInfoAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.lInfoVXAddress.text = this._app.chain.vx.address;
            this.ctrls.lInfoVPoolAddress.text = this._app.chain.vpool.address;
            const validators = yield this._app.chain.vcontroller.getValidatorsCountAsync();
            this.ctrls.lInfoValidators.text = validators !== undefined ? validators : "-";
            const validatorsExiting = yield this._app.chain.vcontroller.getValidatorsToExitAsync();
            this.ctrls.lInfoValidatorsExiting.text = validatorsExiting !== undefined ? validatorsExiting : "-";
            const totalWithdrawal = yield this._app.chain.vx.getTotalWithdrawalValueAsync();
            //this.ctrls.lInfoTotalWithdrawal.text=totalWithdrawal?BiMath.ToEth(BiMath.ToBI(totalWithdrawal)):"-"
            this._shortLabel(this.ctrls.lInfoTotalWithdrawal, totalWithdrawal ? BiMath_1.BiMath.ToBI(totalWithdrawal) : undefined, 3);
            const totalSupply = yield this._app.chain.vxERC20.totalSupply();
            //this.ctrls.lInfoTotalStake.text=totalSupply?BiMath.ToEth(BiMath.ToBI(totalSupply)):"-";
            this._shortLabel(this.ctrls.lInfoTotalStake, totalSupply ? BiMath_1.BiMath.ToBI(totalSupply) : undefined, 3);
        });
    }
    _shortLabel(wr, value = undefined, round = 3) {
        if (!value) {
            wr.text = "-";
            wr.onclick = undefined;
            return;
        }
        wr.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(value), round);
        wr.onclick = () => wr.text = BiMath_1.BiMath.ToEth(value);
    }
    refreshAsync(firstTimeAfterConnect = false) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.blockWithdrawPLS.hide();
            this.ctrls.blockWithdrawVX.hide();
            this.ctrls.btnTabVXS.disable();
            const vxData = yield this._app.chain.vcontroller.getVXRateAsync();
            this._vxRatio = BiMath_1.BiMath.ToBI(vxData.vxRatio);
            this._hotBalance = BiMath_1.BiMath.ToBI(vxData.contedBalance);
            this._shortLabel(this.ctrls.lInfoRatio, this._vxRatio, 5);
            this._shortLabel(this.ctrls.lInfoBalance, this._hotBalance, 3);
            const apr = BiMath_1.BiMath.ToBI(vxData.apr);
            if (apr == BiMath_1.BiMath.Zero)
                this.ctrls.linfoAPR.text = "Calculating";
            else {
                let acc = 1;
                const daily = 1 + parseFloat(vxData.apr) / 365 * 0.91;
                for (let d = 0; d < 365; d++)
                    acc = acc * daily;
                acc = acc - 1;
                this.ctrls.linfoAPR.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(BiMath_1.BiMath.ToBI(acc + "") * BigInt(100)), 3) + "%";
            }
            const vxValidatorGas = yield this._app.chain.vcontroller.getValidatorGas();
            this._vxValidatorGas = BiMath_1.BiMath.ToBI(vxValidatorGas);
            const isConnected = !(!this._app.chain.account);
            this.ctrls.btnTabUnstake.enableSet(isConnected);
            yield this._refreshAdditionalInfoAsync();
            if (isConnected) {
                this.ctrls.btnTabVXS.enable();
                const account = this._app.chain.account;
                const plsBalance = yield this._app.chain.getBalanceEth();
                this._plsBalance = BiMath_1.BiMath.ToBI(plsBalance);
                const vxBalance = yield this._app.chain.vxERC20.balanceOf(account);
                this._vxBalance = BiMath_1.BiMath.ToBI(vxBalance);
                const withdrawalPLS = yield this._app.chain.vx.getWithdrawalAsync(account);
                this._withdrawalPLS = BiMath_1.BiMath.ToBI(withdrawalPLS);
                if (this._withdrawalPLS > 0) {
                    this.ctrls.blockWithdrawPLS.show();
                    let exist = this._hotBalance;
                    if (exist >= this._withdrawalPLS) {
                        exist = this._withdrawalPLS;
                        this.ctrls.btnWithdrawPLS.text = "Withdraw " + BiMath_1.BiMath.ToEth(exist) + " PLS";
                    }
                    else {
                        this.ctrls.btnWithdrawPLS.html = "Withdraw <br>" + BiMath_1.BiMath.ToEth(exist) + " PLS<br>from<br>" + BiMath_1.BiMath.ToEth(this._withdrawalPLS) + " PLS";
                    }
                    if (exist == BiMath_1.BiMath.Zero)
                        this.ctrls.btnWithdrawPLS.disable();
                    else {
                        this.ctrls.btnWithdrawPLS.enable();
                        this.ctrls.btnWithdrawPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
                            const result = yield this._tabVXControl.awaitInLockUIAsync(this._app.chain.vx.withdraw(BiMath_1.BiMath.ToEth(exist), this._app.chain.account));
                            if (result) {
                                this._successFunc();
                                this._tabVXControl.stakeReset();
                                this._tabVXControl.unstakeReset();
                                yield this.refreshAsync();
                            }
                        });
                    }
                }
                else
                    this.ctrls.blockWithdrawPLS.hide();
                const withdrawalVX = yield this._app.chain.vx.getReserveOfAsync(account);
                this._withdrawalVX = BiMath_1.BiMath.ToBI(withdrawalVX.value);
                if (this._withdrawalVX > 0) {
                    this.ctrls.blockWithdrawVX.show();
                    this.ctrls.btnWithdrawVX.onclick = () => __awaiter(this, void 0, void 0, function* () {
                        const result = yield this._tabVXControl.awaitInLockUIAsync(this._app.chain.vx.withdrawReserveAsync());
                        if (result) {
                            this._successFunc();
                            this._tabVXControl.stakeReset();
                            this._tabVXControl.unstakeReset();
                            yield this.refreshAsync();
                        }
                    });
                    const cooldownDelta = parseInt(withdrawalVX.cooldownUntil) - Date.now() / 1000;
                    this.ctrls.btnWithdrawVX.enable();
                    if (cooldownDelta > 0) {
                        this.ctrls.btnWithdrawVX.disable();
                        this.ctrls.btnWithdrawVX.html = "Withdraw " + BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(this._withdrawalVX), 5) + " uPLS<br>" +
                            "cooldown " + (parseInt(cooldownDelta / 60 + "") + 1) + " mins";
                    }
                    else {
                        this.ctrls.btnWithdrawVX.text = "Withdraw " + BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(this._withdrawalVX), 5) + " uPLS";
                    }
                }
                else
                    this.ctrls.blockWithdrawVX.hide();
                this.ctrls.rStakeValuePLS.enable();
                this.ctrls.rUnstakeValueUPLS.enable();
                this._shortLabel(this.ctrls.lInfoValueVX, this._vxBalance + this._withdrawalVX, 3);
                this._shortLabel(this.ctrls.lInfoValuePLS, (this._vxBalance + this._withdrawalVX) * this._vxRatio / BiMath_1.BiMath.Decimal, 3);
            }
            else {
                this.ctrls.rStakeValuePLS.disable();
                this.ctrls.rUnstakeValueUPLS.disable();
                this._shortLabel(this.ctrls.lInfoValueVX);
                this._shortLabel(this.ctrls.lInfoValuePLS);
            }
            let lastActiveTab = this._tabVXControl.getActiveTab();
            if (!this._app.chain.account) {
                this.ctrls.blockConnectWallet.show();
            }
            else {
                this.ctrls.blockConnectWallet.hide();
            }
            if (lastActiveTab)
                this._tabVXControl.activeTab(lastActiveTab);
        });
    }
}
exports.VXControlView = VXControlView;
//# sourceMappingURL=VXControlView.js.map